import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
// Import JSX Modules
import StandardFilterOptions from './standard-filter-options';
import DecapitalisedTitle from '../_utils/decapitalised-title';
import screenAndStyle from '../_utils/screen-and-style';
// Import JS Modules
import genericHelpers from '../_utils/generic-helpers';

// -----------------------------------------------------------
//  MobileFilter
// -----------------------------------------------------------
const MobileFilter = ({ facets, name, title, options, selectedOptions, onOptionSelected, ...props}) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (screenAndStyle.isBootstrapXS()) {
      setCollapsed(true)
    }
    if (selectedOptions && selectedOptions.length){
      setCollapsed(true)
    }
  }, []);

  const handleOptionSelected = (option) => {
    onOptionSelected(name, option, props.multiselectable);
  };
  const handleClearSelected = () => {
    onOptionSelected(name);
  };
  const selectOptionsList = () => {
    return selectedOptions.map(function(option) {
            return option.charAt(0).toUpperCase() + option.slice(1).toLowerCase();
            }).join(', ');
  }

  const toggleCollapse = () => {
    setCollapsed(prevState => !prevState);
  };

  const renderOptions = () => {
    if (collapsed) {
      return null;
    }

    return (
      <div>
        <StandardFilterOptions
          options={options}
          selected_options={selectedOptions}
          facets={facets}
          onOptionSelected={handleOptionSelected} 
        />
        <button className={ classNames('btn btn-secondary btn-sm', {'d-none': !selectedOptions.length}) }
                onClick={ handleClearSelected }>Clear
        </button>
      </div>
    );
  };

  return (
    <section className={ classNames('accordion-entry accordion-entry-mobile-horizontal-padding', { collapsed: collapsed }) }>
      <button
        className="p-2 border-0 bg-white w-100 text-left"
        onClick={ toggleCollapse }
        aria-label={`${ genericHelpers.tidyTitleFilter(title) }`}
        aria-expanded={!collapsed}
        type='button'
      >
        <DecapitalisedTitle>{ genericHelpers.tidyTitleFilter(title) }</DecapitalisedTitle>
      </button>
        <span className={ classNames('list-selected-options-filters', {'d-none': !collapsed}) }>
          { selectOptionsList() }
        </span>
      {renderOptions()}
    </section>
  );
};

export default MobileFilter;
